import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {ContactNewPage} from "../contact-new/contact-new";

@Component({
  selector: 'page-contact-add',
  templateUrl: 'contact-add.html'
})
export class ContactAddPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }

  goToContactNew(params) {
    if (!params) params = {};
    this.navCtrl.push(ContactNewPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact-add/contact-add.ts